
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorDraw as ObiCursorDrawElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-draw.js';
 
 
 

 
 export const ObiCursorDraw = createComponent({
   react: React,
   tagName: 'obi-cursor-draw',
   elementClass: ObiCursorDrawElement,
   events: {
     
   }
  });
 
 